import { GetterTree } from 'vuex'
import * as types from './types'

export default <GetterTree<recipient.state.RecipientState, RootState>>{
	[types.RECIPIENT_LOADING](state) {
		return state.loading
	},

	[types.RECIPIENT_DEPT_LIST](state) {
		return state.orgchart.dept.items
	},

	[types.RECIPIENT_DEPT_PATH](state) {
		return state.orgchart.dept.path
	},

	[types.RECIPIENT_USER_LIST](state) {
		return state.orgchart.dept.items
	},

	[types.RECIPIENT_USER_SELECT](state) {
		return state.orgchart.selectedUsers
	},

	[types.RECIPIENT_VIEW_MODE](state) {
		return state.view
	},

	[types.RECIPIENT_SEARCH](state) {
		return state.searchResults
	},

	[types.RECIPIENT_SEARCH_KEYWORD](state) {
		return state.searchKeyword
	},
	[types.RECIPIENT_COMPPANIES_LIST](state) {
		return state.companies
	},
	[types.RECIPIENT_COMPANY_CHANGE](state) {
		return state.companies
	},
    [types.RECIPIENT_CURRENT_COMPANY](state) {
        return state.currentCompany;
    }
}
